import React, { Component } from "react";
import { Icon, Modal, Button } from "antd";
import { Translate } from "react-translated";

class CustomerExist extends Component {
  render() {
    return (
      <div style={{ marginBottom: 20 }}>
        <Modal
          title={<Translate text={`Confirmation`} />}
          visible={this.props.showModal}
          onCancel={this.props.cancel}
          // cancelText={<Translate text={`View & Edit Existing`} />}
          onOk={this.props.ok}
          okText={<Translate text={`Edit Existing B File`} />}
          maskClosable={false}
          closable={true}
          okButtonProps={{ className: 'borderRadius-28 bg-164897' }}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <div id="customer_exist_modal">
            <p>
              It looks like a profile already exists on this customer. Would you
              like to view & edit the existing B File?
            </p>
          </div>
        </Modal>
      </div>



    );
  }
}

export default CustomerExist;



// WEBPACK FOOTER //
// ./src/scenes/Wizard/parts/customer-exist.js